import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import { getSliceContent } from './content';
import get from '../helpers/get';
import transformLinkProperties from '../server/CMS/transformLinkProperties';
import { createResponsiveSelector, resolveResponsiveSetting } from './settings';

export const getSliceMenuOverlayIsBlack = createResponsiveSelector(content => (
  resolveResponsiveSetting(content, 'menu_overlay_color', setting => setting !== 'White')
));

const getSliceMenuOverlayAlpha = createResponsiveSelector(content => (
  resolveResponsiveSetting(
    content,
    'menu_overlay_opacity',
    setting => Math.min(1, Math.max(0, setting)) || '0.5',
  )
));

const resolveSliceMenuOverlayColor = (isBlack, alpha) => {
  const rgb = isBlack ? '0, 0, 0' : '255, 255, 255';
  return `rgba(${rgb}, ${alpha})`;
};

export const getSliceMenuOverlayColor = createPerSliceIdSelector(
  getSliceMenuOverlayIsBlack,
  getSliceMenuOverlayAlpha,
  (isBlack, alpha) => ({
    mobile: resolveSliceMenuOverlayColor(isBlack.mobile, alpha.mobile),
    desktop: resolveSliceMenuOverlayColor(isBlack.desktop, alpha.desktop),
  }),
);

export const getSliceMenu = createPerSliceIdSelector(
  getSliceContent,
  content => (get(content, ['menu', 'body']) || []).map(menu => ({
    gtm: transformLinkProperties(menu, 'submenu').gtm,
    text: menu.title,
    submenu: (menu.items || []).map(({ clickthrough }) => clickthrough),
  })),
);

export const getSliceActiveMenuIndex = (state, sliceId) => {
  const index = get(state, ['menus', sliceId, 'activeMenuIndex']);
  if (typeof index !== 'number') {
    return -1;
  }
  return index;
};
